import { render, staticRenderFns } from "./QualificationReport.vue?vue&type=template&id=2005c702&scoped=true&"
import script from "./QualificationReport.vue?vue&type=script&lang=js&"
export * from "./QualificationReport.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2005c702",
  null
  
)

export default component.exports